import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import React, { useState } from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { ICalendarTemplateInfo } from "./models";
import RequiredTextInputWithMergeField from "components/ValidatedFields/RequiredTextInputWithMergeField";
import OptionalTextAreaInputWithMergeField from "components/ValidatedFields/OptionalTextAreaInputWithMergeField";
import { nounToLower } from "utilities/translationUtils";

interface ICalendarTemplateNewSectionProps {
  availableMergeFieldTopics: server.dto.AvailableMergeFieldTopic[]
}

export const ICalendarTemplateNewSection = (props: ICalendarTemplateNewSectionProps) => {
  const [value, setValue] = useState<ICalendarTemplateInfo>({
    title: "",
    subject: "",
    body: ""
  });

  const onChange = (newData: Partial<ICalendarTemplateInfo>) => {
    setValue({ ...value, ...newData });
  };

  const submit = () => {
    const instruction: server.dto.CreateICalendarTemplateInstruction = {
      title: value.title,
      subject: value.subject,
      body: value.body,
    }

    return window.CoreApi.ICalendarTemplate.Create(instruction);
  }

  return <EditSectionTemplate
    submit={submit}
    redirectUrl={() => routes.iCalendarTemplate_List().absolute}
    sections={[{
      key: "iCalendarTemplate",
      type: "regular",
      title: RESX.Template.ICalendarTemplate,
      fields: [{
        key: "title",
        label: RESX.GeneralLabels.Title,
        renderEditNew: () => <RequiredTextInput
          validatorKey="title"
          focusOnMount
          maxLength={serverReference.constants.iCalendarTemplate.maxTitleLength}
          value={value.title}
          onChange={(title) => { onChange({ title }); }}
        />
      }, {
        key: "subject",
        label: RESX.Message.Subject,
        renderEditNew: () => <RequiredTextInputWithMergeField
          validatorKey="subject"
          maxLength={serverReference.constants.iCalendarTemplate.maxSubjectLength}
          value={value.subject}
          onChange={(subject) => { onChange({ subject }); }}
          sectionName={nounToLower(site.currentEnvironment.show.singular)}
          availableMergeFieldTopics={props.availableMergeFieldTopics}
        />
      }, {
        key: "body",
        label: RESX.Message.Body,
        renderEditNew: () => <OptionalTextAreaInputWithMergeField
          maxLength={serverReference.constants.iCalendarTemplate.maxBodyLength}
          value={value.body}
          rows={30}
          onChange={(body) => { onChange({ body }); }}
          sectionName={nounToLower(site.currentEnvironment.show.singular)}
          availableMergeFieldTopics={props.availableMergeFieldTopics}
        />
      }]
    }]}
  />
}